<template>
  <div>
    <div class="mask" v-if="dialogVisible" @click="closeVideo">
      <div class="play-video-close">
        <img src="@/assets/images/close-video.png" />
      </div>
    </div>
    <div class="play-video" v-if="dialogVisible">
      <video autoplay loop muted controls="controls" :src="videoSrc"></video>
    </div>
  </div>
</template>

<script>
export default {
    props: {
    visible: {
      type: Boolean,
      default: false,
    },
    videoSrc: {
      type: String,
      default: '',
    },
  },
  watch:{
      visible:function(old,per){
        this.dialogVisible=old
      }
  },
  data() {
      return {
          dialogVisible:false
      }
  },
  methods:{
      closeVideo() {
          this.$emit('update:visible',false)
      }
  }
};
</script>

<style scoped>
.mask{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9998;
  background: rgba(0,0,0,.8);
}
.play-video-close{
  position: absolute;
  right: 32px;
  top: 32px;
  width: 48px;
  height: 48px;
}
.play-video{
  position: absolute;
  left: 50%;
  top: 50%;
  width: 50vw;
  height: 40vh;
  transform: translateX(-50%) translateY(-50%);
  z-index: 9999;
}
video{
  width: 100%;
  height: 100%;
  /*object-fit: cover;*/
}
</style>
